<template>
  <div v-if="!loading" class="p-12 space-y-10">
    <div class="flex space-x-2">
      <BaseButton
        :primary="current === 'PageInsights'"
        :ghost="current !== 'PageInsights'"
        @click="setCurrent('PageInsights')"
      >
        Page Insights
      </BaseButton>
      <BaseButton
        v-if="hasInstagramAccount"
        :primary="current === 'InstagramInsights'"
        :ghost="current !== 'InstagramInsights'"
        @click="setCurrent('InstagramInsights')"
      >
        Instagram Insights
      </BaseButton>
    </div>
    <div>
      <component :is="current" :page-id="pageId" />
    </div>
  </div>
</template>

<script>
import PageInsights from './page-id/page-insights.vue';
import InstagramInsights from './page-id/instagram-insights.vue';

export default {
  components: {
    PageInsights,
    InstagramInsights,
  },
  props: {
    pageId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      current: 'PageInsights',
      loading: false,
    };
  },
  computed: {
    page() {
      return this.$store.state.entities.facebookPages.byId[this.pageId];
    },
    hasInstagramAccount() {
      return (
        typeof this.page?.instagramBusinessAccountId !== 'undefined' &&
        this.page.instagramBusinessAccountId !== null
      );
    },
  },
  created() {
    this.fetchFacebookPage();
  },
  methods: {
    async fetchFacebookPage() {
      try {
        this.loading = true;
        await this.$store.dispatch('admin/facebookPages/read', {
          id: this.pageId,
          query: {
            include: 'accounts',
          },
        });
      } catch (error) {
        // catch any errors
      } finally {
        this.loading = false;
      }
    },
    setCurrent(current) {
      if (current === this.current) {
        return;
      }

      this.current = current;
    },
  },
};
</script>
